import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { VenueManagement } from './components/VenueManagement';

const EdutainmentVenueManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="活動空間時段管理"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '活動空間時段管理',
            },
          ]}
        />
        <VenueManagement />
      </Col>
    </Row>
  );
};

export default EdutainmentVenueManagement;
